export default __webpack_public_path__ + "static/media/fileCompleted.f607691a.svg";